module.exports = {"540422100":"米林镇","540422101":"派镇","540422102":"卧龙镇","540422200":"丹娘乡","540422201":"南伊珞巴民族乡","540422202":"扎西绕登乡","540422203":"里龙乡","540422204":"羌纳乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540422.json
// module id = 2854
// module chunks = 0